/** A minute of the day as a member reads it: 9am, 3:40pm. */
export function clock(minutes) {
    const h = Math.floor(minutes / 60) % 24;
    const m = minutes % 60;
    const suffix = h < 12 ? "am" : "pm";
    const hour = h % 12 === 0 ? 12 : h % 12;
    return m === 0 ? `${hour}${suffix}` : `${hour}:${String(m).padStart(2, "0")}${suffix}`;
}
/** A duration as the member reads it: "45 minutes", "2h", "2h30". */
export function span(minutes) {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    if (h === 0)
        return `${m} minutes`;
    return m === 0 ? `${h}h` : `${h}h${String(m).padStart(2, "0")}`;
}
/** A duration spelled out in full, for a line that reads a measurement against a bar: "1h 35m", "45m". */
export function spanFull(minutes) {
    return minutes >= 60 ? `${Math.floor(minutes / 60)}h ${minutes % 60}m` : `${minutes}m`;
}
/** A number as the member reads it: 1,000. */
export function count(n) {
    return n.toLocaleString("en-GB");
}
// Constructing one costs ~70x formatting with one, and the derive layer asks
// per signal row. Timezone cardinality is one per member, so the map is bounded.
const dayFormatters = new Map();
const timeFormatters = new Map();
function formatterFor(cache, timezone, options) {
    const held = cache.get(timezone);
    if (held)
        return held;
    const made = new Intl.DateTimeFormat(cache === dayFormatters ? "en-CA" : "en-GB", {
        ...options,
        timeZone: timezone,
    });
    cache.set(timezone, made);
    return made;
}
/** The member's local calendar day, as YYYY-MM-DD. */
export function dayKeyIn(at, timezone) {
    return formatterFor(dayFormatters, timezone, {}).format(at);
}
export function sameDayIn(a, b, timezone) {
    return dayKeyIn(a, timezone) === dayKeyIn(b, timezone);
}
/** Minutes past the member's local midnight. Hour 24 is en-GB's local midnight. */
export function minutesIn(at, timezone) {
    const parts = formatterFor(timeFormatters, timezone, {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    }).formatToParts(at);
    const h = Number(parts.find((p) => p.type === "hour")?.value);
    const m = Number(parts.find((p) => p.type === "minute")?.value);
    if (!Number.isFinite(h) || !Number.isFinite(m))
        return null;
    return (h % 24) * 60 + m;
}
/** The same duration from hours instead of minutes, for a reading a device reports that way. */
export function hoursMinutes(hours) {
    if (hours == null)
        return "Not measured";
    return spanFull(Math.round(hours * 60));
}
//# sourceMappingURL=clock.js.map